import React from 'react';
import { VideoParagraph } from '../../Blog/Paragraphs/VideoParagraph';

const OpportunitiesVideos = () => {
    return (
        <div className="opportunities-videos">
            <h2 className="text-2xl font-bold mb-4">Возможности</h2>
            <div className="mb-4 text-gray-600">
                Рассказываем как влияет «Ключ-Астром» на всю команду – от разработки до аналитиков и финансов – для разных категорий бизнеса.
            </div>
            
            <div className="space-y-6">
                <div className="mb-6">
                    <VideoParagraph 
                        width="100%"
                        text=""
                        src="https://www.youtube.com/embed/PQsgwi2iY3o" 
                    />
                </div>
            </div>
        </div>
    );
};

export default OpportunitiesVideos;